import styled from '@emotion/styled'
import type { FC } from 'react'

import AccordionBase, * as Accordion from '@segment/matcha/recipes/Accordion'

import { useActiveState } from '@segment/utils/useActiveState'

import { data } from './data'

const Faq: FC = () => {
  const items = Array(data.length).fill(false)
  const { activeItems, toggle } = useActiveState(items, {
    allowMultipleActive: true,
  })
  return (
    <Wrapper>
      {activeItems.map((active, index) => (
        <AccordionBase key={`item-${index}`}>
          <Accordion.Header onClick={() => toggle(index)}>
            <Accordion.TitleWrapper>
              <Accordion.Title opened={active}>{data[index].title}</Accordion.Title>
              <Accordion.SubTitle>{data[index].description}</Accordion.SubTitle>
            </Accordion.TitleWrapper>
            <Accordion.Icon opened={active} />
          </Accordion.Header>
          <Accordion.Body>
            {active && <Accordion.ContentWrapper>{data[index].image}</Accordion.ContentWrapper>}
          </Accordion.Body>
        </AccordionBase>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div``

export default Faq
